// extracted by mini-css-extract-plugin
export default {"notebook-msg":"NotebookHome_notebook-msg__2uYY+","notebook-msg__text":"NotebookHome_notebook-msg__text__FhbuU"};